// extracted by mini-css-extract-plugin
export var content = "ImageTextPanel-module--content--52564";
export var image = "ImageTextPanel-module--image--decb1";
export var imageLeft = "ImageTextPanel-module--imageLeft--f5cbe";
export var wrapper = "ImageTextPanel-module--wrapper--c53d6";